/**
 * Sanitizes a string by replacing non-breaking spaces and other special whitespace
 * with standard spaces, then trims the result.
 */
export const sanitizeAndTrim = (value: string): string => {
  return value
    .replace(/\u00a0/g, " ") // Replace &nbsp; (\u00a0)
    .replace(/\s+/g, " ") // Replace multiple whitespace with single space
    .trim(); // Trim leading/trailing whitespace
};
